import { useContext } from 'react';
import ThemeContext from './views/ThemeContext';
export default (function () {
  return useContext(ThemeContext);
});